import React from 'react'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import CustomCard from '../CustomCard/CustomCard'

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  payload,
}) => {
  const RADIAN = Math.PI / 180
  const radius = outerRadius + 15
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {payload.value}
    </text>
  )
}

export default function CustomPieChart({ title, items, cellColors, borderTopColor, height = 150 }) {
  return (
    <CustomCard title={title} style={{ borderTop: `5px solid ${borderTopColor}` }}>
      {items.length === 0 ? (
        <h5>Não Existe Ocorrências</h5>
      ) : (
        <div style={{ height: height }}>
          <ResponsiveContainer height={height} width="100%">
            <PieChart>
              <Pie
                data={items}
                innerRadius={40}
                outerRadius={60}
                paddingAngle={5}
                dataKey="value"
                labelLine={false}
                label={renderCustomizedLabel}
              >
                {items.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={cellColors[index % cellColors.length]} />
                ))}
              </Pie>
              <Legend verticalAlign="center" layout="vertical" align="right" height={36} />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </CustomCard>
  )
}
